import { Preferences } from "@capacitor/preferences";
import type { SearchToursResponse } from "../api/types";
import type { Tour } from "./types";
import { LANGUAGE_STORAGE_KEY } from "@/utils/i18n";

export function createToursList(response: SearchToursResponse): Array<Tour> {
  return (response.items ?? []).map((item) => ({
    id: item.id,
    name: item.name,
    state: item.state,
    date: item.scheduledStart ?? new Date(),
  }));
}

export async function getStoredLanguage() {
  try {
    const { value } = await Preferences.get({ key: LANGUAGE_STORAGE_KEY });
    return value;
  } catch (error) {
    console.error("Failed to get language preference:", error);
    return null;
  }
}

export async function setStoredLanguage(lng: string) {
  try {
    await Preferences.set({ key: LANGUAGE_STORAGE_KEY, value: lng });
  } catch (error) {
    console.error("Failed to set language preference:", error);
  }
}
